module.exports = __webpack_public_path__ + "img/5-2_02.e3e2a168.jpg";